'use client';
import React from 'react';
import SpecificationTab from './SpecificationTab';
import cn from './style.module.scss';

export default function GardeniaLaunchSpecification(props: any) {
  const { t } = props;
  return (
    <section className={cn.launchGRDSpecification}>
      <SpecificationTab t={t} tabImages={props.tabImages} />
    </section>
  );
}
